import { useQuery } from '@apollo/client/react';
import startCase from 'lodash/startCase';
import React from 'react';
import {
  AutocompleteArrayInput,
  Filter,
  SelectInput,
  TextInput,
} from 'react-admin';
import { AdminGetAuditLogFilterOptionsDocument } from '../../../graphql/types';

export const AuditLogFilters: React.FC<Record<string, unknown>> = (props) => {
  const { data: filtersData } = useQuery(AdminGetAuditLogFilterOptionsDocument);

  const actionChoices = (filtersData?.auditLogActions ?? []).map((action) => ({
    id: action.value,
    name: action.name ?? startCase(action.value),
  }));

  const categoryChoices = (filtersData?.auditLogCategories ?? []).map(
    (category) => ({
      id: category.value,
      name: category.name ?? startCase(category.value),
    }),
  );

  return (
    <Filter {...props}>
      <SelectInput
        alwaysOn
        source="category"
        label="Category"
        choices={categoryChoices}
        sx={{
          width: '240px',
          '&': { margin: 0 },
        }}
      />
      <AutocompleteArrayInput
        alwaysOn
        source="action"
        label="Action"
        choices={actionChoices}
        sx={{
          width: '240px',
        }}
      />
      <TextInput
        alwaysOn
        source="dataId"
        label="Data ID"
        sx={{ width: '320px' }}
      />
    </Filter>
  );
};
